var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", function() {
                  return [
                    _c("category-image-carousel", {
                      ref: "categoryImageCarousel",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        title: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel":
                          _vm.$ceres.config.item.enableImageCarousel,
                        "disable-carousel-on-mobile":
                          _vm.disableCarouselOnMobile
                      }
                    })
                  ]
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wish-wrapper" },
                  [
                    _c("add-to-wish-list", {
                      attrs: { "variation-id": _vm.item.variation.id }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.tagName && !_vm.isClosed()
                  ? _c("div", { staticClass: "tag" }, [
                      _c("span", { staticClass: "badge bg-danger" }, [
                        _vm._v(_vm._s(_vm.tagName))
                      ])
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.isClosed()
              ? _c("div", { staticClass: "closed" }, [
                  _c(
                    "a",
                    {
                      staticClass: "message",
                      attrs: {
                        href: _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        )
                      }
                    },
                    [_vm._m(0)]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.badge && _vm.sales() && !_vm.isClosed()
              ? _c("p", { staticClass: "sales-badge mb-0" }, [
                  _c("span", {
                    class: "badge badge-" + _vm.badge.color,
                    domProps: { innerHTML: _vm._s(_vm.badge.text) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.hasProperty82()
              ? _c("p", { staticClass: "ki-info mb-0" }, [
                  _c("span", { staticClass: "badge" }, [
                    _c("i", {
                      staticClass: "fa fa-info-circle mr-1",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(
                      _vm._s(_vm.$translate("FanLiebling::Singleitem.KIImage"))
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm._t("store-special", function() {
            return [
              _vm.storeSpecial ||
              _vm.item.variation.bundleType === "bundle" ||
              _vm.item.item.itemType === "set"
                ? _c("item-store-special", {
                    attrs: {
                      "store-special": _vm.storeSpecial,
                      "recommended-retail-price": _vm.item.prices.rrp,
                      "variation-retail-price": _vm.item.prices.default,
                      "special-offer-price": _vm.item.prices.specialOffer,
                      "decimal-count": _vm.decimalCount,
                      "bundle-type": _vm.item.variation.bundleType,
                      "item-type": _vm.item.item.itemType
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _vm._t("item-details", function() {
            return [
              _c(
                "div",
                { staticClass: "thumb-content" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-start"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "thumb-title",
                          attrs: {
                            href: _vm._f("itemURL")(
                              _vm.item,
                              _vm.urlWithVariationId
                            )
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("itemName")(_vm.item)) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.probability()
                        ? _c(
                            "div",
                            {
                              staticClass: "probability mb-0 position-relative",
                              on: {
                                mouseover: function($event) {
                                  _vm.showTooltip = true
                                },
                                mouseleave: function($event) {
                                  _vm.showTooltip = false
                                }
                              }
                            },
                            [
                              _vm.showTooltip
                                ? _c("div", { staticClass: "custom-tooltip" }, [
                                    _vm._v("Unsere Einschätzung")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "content" },
                                [
                                  _vm.probability() !== false
                                    ? [
                                        _c("i", {
                                          staticClass: "fa fa-handshake-o",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" "),
                                        _vm.probability() === "?"
                                          ? _c("span", [
                                              _vm._v(_vm._s(_vm.probability()))
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.probability()) + "%"
                                              )
                                            ])
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.progression() !== false
                                    ? [
                                        _c("i", {
                                          class: {
                                            "fa text-danger fa-angle-double-down":
                                              _vm.progression() === "Fallend",
                                            "fa text-success fa-angle-double-up":
                                              _vm.progression() === "Steigend"
                                          },
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "thumb-meta" },
                    [
                      _c("div", { staticClass: "rumor-wrapper my-2" }, [
                        _vm.fromClub() && _vm.toClub()
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "clubs d-flex justify-content-between align-items-center"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._t("from-club-name")],
                                  2
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "fa fa-long-arrow-right arrow mx-3",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._t("to-club-name")],
                                  2
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.marketValue()
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "w-100 justify-content-between marketValue d-none"
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.marketValue()) + "€")
                                ])
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm._t("before-prices")
                    ],
                    2
                  ),
                  _vm._v(" "),
                  false
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "progress-bar-container position-relative border-radius mt-2",
                          on: {
                            mouseover: function($event) {
                              _vm.showTooltip = true
                            },
                            mouseleave: function($event) {
                              _vm.showTooltip = false
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "progress-bar border-radius",
                            style: { width: _vm.progressWidth + "%" }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "w-100 flex-wrap align-items-center progress-info-left mb-4"
                        },
                        [
                          _c("div", {
                            staticClass: "progress-info-border",
                            style: { width: _vm.progressWidth + "%" }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "pl-2 small" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "FanLiebling::Singleitem.progressReached"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-block btn-primary btn-appearance font-weight-bold border-radius",
                      attrs: {
                        href: _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        )
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-arrow-right mr-1",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Zu deinem Liebling!")])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._t("after-prices")
                ],
                2
              )
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", {
        staticClass: "fa fa-lock mr-1",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v("Gerücht geschlossen")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }